import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const shimmer = keyframes`
  0%   { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

export const Skeleton = styled.div<{
  $w?: string;
  $h?: string;
  $r?: string;
}>`
  width: ${({ $w = '100%' }) => $w};
  height: ${({ $h = '14px' }) => $h};
  border-radius: ${({ $r = '6px' }) => $r};
  background: linear-gradient(90deg, var(--bg-hover) 25%, var(--bg-input) 50%, var(--bg-hover) 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.4s ease infinite;
`;

export const SkeletonCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid var(--border-subtle);
  background: var(--bg-panel-elevated);
`;

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
